<template>
  <div class="flex pt16 pl12 pr16 product-list">
    <div class="img-content">
      <van-image width="72" height="72" :src="item.mainImg" :ref="'fly-img' + item.itemId"></van-image>
      <template v-if="!expire">
        <span v-if="item.status === 1" class="no-stockNum">下架</span>
        <span v-else-if="item.stockNum === 0" class="no-stockNum">售罄</span>
        <div class="mask" v-if="item.status === 1 || (item.status !== 1 && item.stockNum === 0)"></div>
      </template>
    </div>
    <div
      class="right"
      :class="{ 'show-bottom-border': !showBorder, disabled: (item.stockNum === 0 || item.status === 1) && !expire }"
    >
      <div class="name ellipsis">
        {{ item.itemName }}
      </div>
      <div class="company ellipsis">
        {{ item.enterprise }}
      </div>
      <div class="size">
        {{ item.specifications }}
      </div>
      <div class="flex space-between mt8">
        <div class="price">
          <div v-if="!expire">
            {{ item.realPrice | parsePrice }}
          </div>
          <!-- isChage 人为改动不提示库存不足 -->
          <div
            class="tip"
            v-if="!expire && !item.isChage && item.amount !== item.itemNum && item.stockNum && !item.status"
          >
            库存不足，已调整到最大值
          </div>
        </div>
        <div class="action">
          <template v-if="expire">
            <span style="color: #8c8c8c">x {{ item.itemNum }}</span>
          </template>
          <template v-else>
            <van-stepper
              :ref="'stepper' + item.itemId"
              :value="item.amount || ''"
              theme="round"
              allow-empty
              @plus="plus"
              @minus="minus"
              @blur="handleBlur"
              @overlimit="overlimit"
              @change="handChange"
              integer
              async-change
              :show-minus="item.amount > 0"
              :show-plus="item.stockNum !== 0"
              :min="1"
              :max="item.stockNum < 999 ? item.stockNum : 999"
              button-size="22"
              :disable-input="item.amount === 0"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['item', 'flyButton', 'showBorder', 'expire'],

  data() {
    return {
      digit: '',
      isTip: false // 是否提示用户
    };
  },
  methods: {
    // 删除购物车
    deleteTrolley() {
      const { itemId, isDrug } = this.item;
      this.$dialog
        .confirm({
          title: '确认删除该商品？',
          confirmButtonText: '再想想',
          cancelButtonText: '删除'
        })
        .then(() => {
          this.$refs['stepper' + itemId].currentValue = this.item.amount;
        })
        .catch(() => {
          this.$emit('handleDelete', itemId);
        });
    },
    addTrolley(amount, bol) {
      if (amount === this.item.amount) {
        if (this.item.stockNum === amount) {
          this.$toast(`您最多可购买${this.item.stockNum}件`);
        }
        if (amount === 999) {
          this.$toast(`您最多可购买999件`);
        }
        return;
      }

      const { itemId, isDrug } = this.item;

      if (bol) {
        this.$toast('输入商品数量至少1件');
      }

      if (this.isTip) {
        this.overlimit();
      }
      this.item.amount = amount;
    },
    minus() {
      const amount = Number(this.$refs['stepper' + this.item.itemId].currentValue) - 1;
      if (amount < 1) {
        // this.deleteTrolley();
        return;
      }
      this.addTrolley(amount);
    },
    plus() {
      const amount = Number(this.$refs['stepper' + this.item.itemId].currentValue) + 1;
      this.addTrolley(amount);
    },
    handleBlur() {
      const amount = Number(this.$refs['stepper' + this.item.itemId].currentValue);

      if (amount === 0) {
        this.$refs['stepper' + this.item.itemId].currentValue = 1;
        return this.addTrolley(1, true);
      }
      this.addTrolley(amount);
    },
    // 点击不可用按钮触发
    overlimit(val) {
      if (val === 'minus') {
        this.$toast('您不能再减了哦');
        return;
      }

      if (this.item.stockNum < 999) {
        this.$toast(`您最多可购买${this.item.stockNum}件`);
      } else {
        this.$toast('您最多可购买999件');
      }
    },
    handChange(v) {
      this.item.isChage = true;
      if (v === 999 || v === this.item.stockNum) return;
      this.isTip = !!(Number(v) > this.item.stockNum);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list {
  width: 100%;
  position: relative;

  .drop-image {
    position: absolute;
    top: 0;
    left: 0;
  }
}
.show-bottom-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.img-content {
  position: relative;
  .mask {
    position: absolute;
    display: inline-block;
    width: 72px;
    height: 72px;
    left: 0;
    top: 0;
    background: rgba(51, 51, 51, 0.8);
    z-index: 1;
    border-radius: 4px;
    opacity: 0.5;
  }
  .no-stockNum {
    position: absolute;
    display: inline-block;
    width: 50px;
    height: 50px;
    z-index: 2;
    background: #333333;
    box-shadow: 0px 1px 4px 0px rgba(51, 51, 51, 0.5);
    opacity: 0.8;
    top: 11px;
    left: 11px;
    border-radius: 50px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 50px;
  }
}

.right {
  margin-left: 8px;
  width: calc(100% - 78px);
  padding-bottom: 12px;

  .name {
    font-size: 16px;
    line-height: 24px;
    color: #262626;
    font-weight: 500;
  }
  .company,
  .size {
    line-height: 16px;
    margin-top: 4px;
    font-size: 12px;
    color: #8c8c8c;
  }
  .price {
    font-size: 14px;
    font-weight: 500;
    color: #f94242;
    line-height: 24px;
    .tip {
      font-weight: 400;
      color: #f94242;
      font-size: 12px;
      line-height: 20px;
      transform: scale(0.9, 0.9) translateX(-8px);
    }
  }

  &.disabled {
    .name,
    .company,
    .size,
    .price {
      color: #bfbfbf;
    }
  }

  .sub_button {
    width: 88px;
    height: 24px;
    padding: 0;
    border-radius: 4px;
  }
  ::v-deep.van-stepper__minus {
    color: #262626;
    background-color: #fff;
    border: 1px solid #118dff;
  }
  ::v-deep.van-stepper__plus {
    color: #fff;
    background-color: #1e8dff;
  }
  ::v-deep.van-stepper__plus,
  ::v-deep.van-stepper__minus {
    border-radius: 6px;
  }
}
</style>
